(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmInsurance', CrmInsurance);

    CrmInsurance.$inject = ['$resource', 'DateUtils'];

    function CrmInsurance ($resource, DateUtils) {
        var resourceUrl =  'api/crm-insurances/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'findOneByFilter': {url: 'api/crm-insurances/filter', method: 'POST', isArray: false}
        });
    }
})();
